import styles from "../ImgContestPage/ImagePage.module.css";
import React, {
  useContext,
  useEffect,
  useState,
  useRef,
  useCallback,
} from "react";
import Context from "../../context/Context";
import Play from "../../../src/assests/play.svg";
import likes from "../../../src/assests/whiteheart.png";
import views from "../../../src/assests/eye.svg";
import Popup from "../Popup/Popup";
import axios from "axios";
import trophy from "../../assests/trophy.png";
import vsIcon from "../../assests/vsIcon.svg";
import { useUserAuth } from "../../context/UserAuthContext";
import usePageImageGalleryScroll from "../../hooks/usePageImageGalleryScroll";
import loadingAnimation from "../../assests/loading.json";
import Lottie from "react-lottie-player";
import * as _ from "lodash";
import Bluearrow from "../../assests/blueArrow.png";
import likeInContest from "../../assests/likeInContest.svg";
import multipleFile from "../../assests/multipleFile.svg";

import { useLocation, useNavigate } from "react-router";
import LikePopup from "../LikePopup/LikePopup";
import { createSearchParams } from "react-router-dom";
import PredictionPopup from "../PredictionPopup/PredictionPopup";
import GroupedPopup from "../GroupedPopup/GroupedPopup";
let cancelTokenSource = null;

function ImageGallery({
  userToken,
  campaignId,
  contestId,
  organiserId,
  campaignType,
  buttonColor,
  contestDetails,
}) {
  const {
    verifyUser,
    userIdToken,
    campaignMetaData,
    details,
    clickedImg,
    setClickedImg,
    likeMap,
    setLikeMap,
    pageNumber,
    setPageNumber,
    viewMore,
    setViewMore,
    setContestImageGalleryContents,
    contestScrollPositionRef,
    setHasMore,
  } = useContext(Context);

  const [currentIndex, setCurrentIndex] = useState(null);
  const [like, setLike] = useState();
  const [isViewed, setisViewed] = useState(false);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const [likePopup, setLikePopup] = useState(false);
  const [likeMessage, setLikeMessage] = useState("");

  const {
    currentUser,
    guestModeEnabled,
    setPreviousLocation,
    setGuestModeEnabled,
    searchParams,
  } = useUserAuth();
  const token = userIdToken || currentUser?.accessToken;
  const organizerName_fromURL = window.location.href.split("/")[3];
  const navigate = useNavigate();
  const [matches, setMathes] = useState([]);
  const [groupedEntris, setGroupedEntries] = useState([]);
  const [predicitonPopup, setPredictionPopup] = useState(false);
  const [mathesLoading, setMatchesLoading] = useState(false);
  const [likesAndViewOfUser, setLikesAndViewOfUser] = useState({});
  const [likeMapObjApi, setLikeMapObjApi] = useState({});
  const [initialRender, setInitialRender] = useState(false);
  const [groupedPageNumber, setGroupedPageNumber] = useState(1);
  const [groupedPopup, setGroupedPopup] = useState({});

  useEffect(() => {
    if (contestDetails?.contestType == "WPM") {
      getMatches();
    }
  }, [contestDetails]);
  useEffect(() => {
    if (contestDetails?.contestType == "SERIES") {
      getGroupedEntries();
    }
  }, [contestDetails, pageNumber]);

  const { dataloading, error, contestImageGalleryContents, hasMore } =
    usePageImageGalleryScroll(
      pageNumber,
      token,
      campaignId,
      contestId,
      organiserId,
      guestModeEnabled,
      campaignMetaData,
      viewMore,
      likeMap,
      setLikeMap,
      initialRender,
      setInitialRender,
      contestDetails
    );

  const observer = useRef();
  const lastElementRef = useCallback(
    (node) => {
      if (dataloading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore && viewMore) {
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
          setGroupedPageNumber((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [dataloading, hasMore, viewMore]
  );

  useEffect(() => {
    // setContestImageGalleryContents([]);
    verifyUser();
  }, []);

  useEffect(() => {
    likeChecker();
  }, [organiserId, campaignId, contestId]);
  useEffect(() => {
    const updatedLikeMap = new Map(likeMap);
    const likedEntryObject = likeMapObjApi;
    if (likedEntryObject) {
      Object?.entries(likedEntryObject)?.forEach(([key, value]) => {
        if (updatedLikeMap.has(key)) {
          const obj = { ...updatedLikeMap.get(key), ...value };

          updatedLikeMap.set(key, obj);
        } else {
          updatedLikeMap.set(key, value);
        }
      });

      setLikeMap(updatedLikeMap);
    }
  }, [likeMapObjApi]);

  const likeChecker = async () => {
    setLoading(true);
    try {
      let config = {
        method: "GET",
        url: `${process.env.REACT_APP_LIKECHECK}/${organiserId}/${campaignId}/${contestId}`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
      const response = await axios(config);
      setLikesAndViewOfUser(response?.data?.result);
      setLikeMapObjApi(response?.data?.result);
      setLoading(false);
    } catch (error) {
      console.log(error.message);
    }
  };
  useEffect(() => {
    if (!_.isEmpty(clickedImg) && !_.isEmpty(likesAndViewOfUser)) {
      let idToCheck = "con" + clickedImg?._id;
      setLike(likesAndViewOfUser[idToCheck]?.liked ? true : false);
      setisViewed(likesAndViewOfUser[idToCheck]?.viewed ? true : false);
    }
  }, [likesAndViewOfUser]);
  const likeOrDislike = async (item, isLike) => {
    const campaignId = item?.campaignId;
    const contestId = item?.contestId;
    const videoId = item?._id;
    let url = "";
    if (isLike === true) {
      url = `${process.env.REACT_APP_LIKE}/${organiserId}/${campaignId}/${contestId}/${videoId}?command=like`;
    } else {
      // url = `${process.env.REACT_APP_LIKE}/${organiserId}/${campaignId}/${contestId}/${videoId}?command=disLike`;
      url = `${process.env.REACT_APP_LIKE}/${organiserId}/${campaignId}/${contestId}/${videoId}?command=like`;
    }
    // setLoading(true);
    // Cancel the previous request (if any)
    if (cancelTokenSource !== null) {
      cancelTokenSource.cancel("Request canceled due to button click.");
    }

    // Create a new cancel token source

    cancelTokenSource = axios.CancelToken.source();
    try {
      let config = {
        method: "post",
        url: url,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        cancelToken: cancelTokenSource.token,
      };
      const response = await axios(config);
      // setLike(!item.isLiked);
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log("Request canceled:", error.message);
      } else {
        console.log("Error:", error.message);
      }
    }
  };
  useEffect(() => {
    return () => {
      if (cancelTokenSource) {
        cancelTokenSource.cancel("Request canceled due to component unmount.");
        cancelTokenSource = null;
      }
    };
  }, []);
  const getMatches = async () => {
    if (contestId && campaignId) {
      setMatchesLoading(true);

      let url = `${process.env.REACT_APP_GET_MATCHES}/${organiserId}/${campaignId}/${contestId}`;

      axios({
        method: "get",
        url: url,
      })
        .then((res) => {
          let entris = res.data.data;
          setMathes(entris);
          setMatchesLoading(false);
        })
        .catch((e) => {
          setMatchesLoading(false);
        });
    }
  };

  const getGroupedEntries = async () => {
    setViewMore(true);
    if (contestId && campaignId) {
      setMatchesLoading(true);
      let url = `${process.env.REACT_APP_GET_GROUPED_ENTRIES}/${organiserId}/${campaignId}/${contestId}?page=${groupedPageNumber}&limit=5`;

      axios({
        method: "get",
        url: url,
      })
        .then((res) => {
          let entris = res.data.data;
          setGroupedEntries((prevContestData) => {
            return [...new Set([...prevContestData, ...entris])];
          });
          setHasMore(entris?.length > 0);
          setMatchesLoading(false);
        })
        .catch((e) => {
          setMatchesLoading(false);
        });
    }
  };
  // const initializeLike = (item) => {
  //   let idToCheck = "con" + item?._id;
  //   if (
  //     likesAndViewOfUser[idToCheck] === undefined &&
  //     !_.isEmpty(likesAndViewOfUser)
  //   ) {
  //     setLikesAndViewOfUser({
  //       ...likesAndViewOfUser,
  //       [idToCheck]: { liked: false, viewed: false },
  //     });
  //     setLike(false);
  //   } else {
  //     if (likesAndViewOfUser[idToCheck]?.liked) {
  //       setLike(true);
  //     } else {
  //       setLike(false);
  //     }
  //   }
  // };

  const initializeView = (item) => {
    let idToCheck = "con" + item?._id;

    if (
      likesAndViewOfUser[idToCheck] === undefined &&
      !_.isEmpty(likesAndViewOfUser)
    ) {
      setLikesAndViewOfUser({
        ...likesAndViewOfUser,
        [idToCheck]: { liked: false, viewed: false },
      });
      setisViewed(false);
    } else {
      if (likesAndViewOfUser[idToCheck]?.viewed) {
        setisViewed(true);
      } else {
        setisViewed(false);
      }
    }
  };
  const handleClick = async (item, index) => {
    contestScrollPositionRef.current = window.scrollY;
    navigate(
      {
        pathname: `/${item?.orgDomain}/${item?.campaignUniqueText}/${item?.contestUniqueText}/${index}`,
        search: `${searchParams ? createSearchParams(searchParams) : ""}`,
      },
      { state: { previousLocation: location?.pathname } }
    );
    setCurrentIndex(index);
    setClickedImg(item);
    // initializeLike(item);
    initializeView(item);
  };

  const handleLike = async (isLike, mapId, index, source) => {
    const updatedLikeMap = new Map(likeMap);
    let likeObj = updatedLikeMap.get(mapId);
    let phone = currentUser?.phoneNumber;
    let regions = "";
    let verified = false;
    if (!_.isEmpty(details?.likeAllowedCountries)) {
      details?.likeAllowedCountries?.forEach((element, i) => {
        if (phone?.startsWith(element?.code)) {
          verified = true;
        }
        regions += element?.country;
        if (i < details?.likeAllowedCountries.length - 1) {
          regions += ", ";
        }
      });
      if (!verified) {
        setLikePopup(true);
        setLikeMessage(
          `Votes for this contest are limited to mobile numbers under the region(s) - "${regions}"`
        );
        return;
      }
    }
    if (contestDetails?.likeClosed) {
      setLikeMessage(
        `Unfortunately, we are unable to accept any more votes at this time as the contest has officially concluded.`
      );
      setLikePopup(true);
    } else {
      if (isLike) {
        if (source == "signup") {
          if (!likeObj.liked) likeObj.likesCount = likeObj?.likesCount + 1;
        } else {
          likeObj.likesCount = likeObj?.likesCount + 1;
        }
        likeObj.liked = isLike;
        updatedLikeMap.set(mapId, likeObj);
        setLikeMap(updatedLikeMap);
        let idToCheck = "con" + contestImageGalleryContents[index]?._id;
        await likeOrDislike(contestImageGalleryContents[index], isLike);
      } else {
        setLikeMessage(`You've already liked this post. 
Thank you for your support!`);
        setLikePopup(true);
      }
    }
  };
  useEffect(() => {
    if (location?.state?.like) {
      const popupData = contestImageGalleryContents?.filter((item) => {
        return (
          contestImageGalleryContents?.indexOf(item) === location?.state?.index
        );
      });
      const newItem = popupData[0];
      handleClick(newItem, location?.state?.index);
      if (
        location?.state?.like &&
        likeMap.has(location?.state?.id) &&
        !loading
      ) {
        handleLike(
          location?.state?.request,
          location?.state?.id,
          location?.state?.index,
          "signup"
        );
        let updatedState = { ...location?.state, like: false };
        navigate(null, { replace: true, state: updatedState });
      }
    }
  }, [likeMap]);
  useEffect(() => {
    if (currentIndex + 1 == 9) {
      if (!guestModeEnabled) {
        setViewMore(true);
      }
    }
  }, [currentIndex]);

  // useEffect(() => {
  //   if (location?.state?.viewMore) {
  //     const popupData = contestImageGalleryContents?.filter((item) => {
  //       return (
  //         contestImageGalleryContents?.indexOf(item) === location?.state?.index
  //       );
  //     });
  //     const newItem = popupData[0];
  //     handleClick(newItem, location?.state?.index);

  //     navigate(null, { replace: true, state: {} });
  //   }
  // }, []);
  const handelRotationRight = () => {
    const totalLength = contestImageGalleryContents?.length;
    if (currentIndex + 1 == 9) {
      if (guestModeEnabled) {
        setPreviousLocation(window.location.pathname);
        navigate(`/signup`, {
          state: {
            previousLocation: location?.pathname,
            viewMore: true,
            index: currentIndex,
          },
        });
      }
    } else if (currentIndex + 1 >= 6 && currentIndex + 1 <= 9) {
      if (!guestModeEnabled) {
        setViewMore(true);
      }
    }
    if (currentIndex + 3 >= totalLength) {
      if (hasMore) {
        setPageNumber(pageNumber + 1);
      }
    }
    let newIndex = currentIndex + 1;
    if (newIndex === totalLength) {
      newIndex = 0;
    }
    const newUrl = contestImageGalleryContents?.filter((item) => {
      return contestImageGalleryContents?.indexOf(item) === newIndex;
    });
    const newItem = newUrl[0];
    if (guestModeEnabled === false) {
      // initializeLike(newItem);
      initializeView(newItem);
    }

    setClickedImg(newItem);
    setCurrentIndex(newIndex);
  };

  const handelRotationLeft = () => {
    const totalLength = contestImageGalleryContents?.length;
    if (currentIndex === 0) {
      setCurrentIndex(totalLength - 1);
      const newUrl =
        contestImageGalleryContents &&
        contestImageGalleryContents[totalLength - 1];
      setClickedImg(newUrl);
      return;
    }
    const newIndex = currentIndex - 1;
    const newUrl = contestImageGalleryContents?.filter((item) => {
      return contestImageGalleryContents?.indexOf(item) === newIndex;
    });
    const newItem = newUrl[0];
    if (guestModeEnabled === false) {
      // initializeLike(newItem);
      initializeView(newItem);
    }
    setClickedImg(newItem);
    setCurrentIndex(newIndex);
  };

  const isPrevDisabled = currentIndex === 0;
  const isNextDisabled =
    currentIndex === contestImageGalleryContents?.length - 1 && !hasMore;

  // let mybutton = document.getElementById("myBtn");

  // When the user scrolls down 20px from the top of the document, show the button
  // window.onscroll = function () { scrollFunction() };

  // function scrollFunction() {
  //   if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
  //     mybutton.style.display = "block";
  //   } else {
  //     mybutton.style.display = "none";
  //   }
  // }

  // When the user clicks on the button, scroll to the top of the document
  // function topFunction() {
  //   // alert("Scrolling up")
  //   document.body.scrollTop = 0;
  //   document.documentElement.scrollTop = 0;
  // }
  // const [touchStart, setTouchStart] = useState(null);
  // const [touchEnd, setTouchEnd] = useState(null);

  // const minSwipeDistance = 50;
  // const onTouchStart = (e) => {
  //   setTouchEnd(null); // otherwise the swipe is fired even with usual touch events
  //   setTouchStart(e.targetTouches[0].clientY);
  // };

  // const onTouchMove = (e) => setTouchEnd(e.targetTouches[0].clientY);

  // const onTouchEnd = (e) => {
  //   if (!touchStart || !touchEnd) return;
  //   const distance = touchStart - touchEnd;
  //   e.preventDefault();
  //   const isUpSwipe = distance > minSwipeDistance;
  //   const isDownSwipe = distance < -minSwipeDistance;
  //   if (isUpSwipe) {
  //     handelRotationRight();
  //   }
  //   if (isDownSwipe) {
  //     handelRotationLeft();
  //   }
  // };
  const handleViewAllEntries = () => {
    if (guestModeEnabled) {
      setPreviousLocation(window.location.pathname);
      navigate(`/signup`, {
        state: { previousLocation: location?.pathname },
      });
    } else {
      setViewMore(true);
    }
  };
  // if (clickedImg) {
  //   return (
  //     <>
  //       {likePopup && (
  //         <LikePopup
  //           setPopup={setLikePopup}
  //           backgroundColor={contestDetails?.buttonColor}
  //           message={likeMessage}
  //         />
  //       )}
  //       <Popup
  //         clickedImg={clickedImg}
  //         handelRotationRight={handelRotationRight}
  //         setClickedImg={setClickedImg}
  //         handelRotationLeft={handelRotationLeft}
  //         handleLike={handleLike}
  //         isLike={like}
  //         isViewed={isViewed}
  //         likesAndViewOfUser={likesAndViewOfUser}
  //         setLikesAndViewOfUser={setLikesAndViewOfUser}
  //         contestContent={contestImageGalleryContents[currentIndex]}
  //         loading={loading}
  //         token={userIdToken}
  //         currentIndex={currentIndex}
  //         campaignType={campaignType}
  //         contestDetails={contestDetails}
  //         likeMap={likeMap}
  //         isNextDisabled={isNextDisabled}
  //         isPrevDisabled={isPrevDisabled}
  //         dataloading={dataloading}
  //       />
  //     </>
  //   );
  // } else {
  let galleryJSX = <></>;
  switch (contestDetails?.contestType) {
    case "WPM":
      galleryJSX = (
        <div className="pt-[12px] px-[20px] relative">
          <p className="text-large-medium mb-[12px]">Fixtures</p>
          {mathesLoading ? (
            <div>
              <div className="w-full max-w-[425px] flex align-center justify-center">
                <Lottie
                  loop
                  animationData={loadingAnimation}
                  play
                  style={{ width: 200, height: 100 }}
                />
              </div>
              <p className="w-[100%] text-small text-center text-[#7AA4F8]">
                Loading Fixtures
              </p>
            </div>
          ) : (
            <>
              {matches?.map((obj) => {
                const matchDetails = obj;
                const matchDate = new Date(matchDetails?.matchDate);
                const formattedMatchDate = `${matchDate.toLocaleString(
                  "default",
                  {
                    month: "long",
                  }
                )} ${matchDate.getUTCDate()} ${matchDate.getUTCFullYear()} , ${matchDate.toLocaleTimeString()}`;
                const team1Score = obj?.team1?.predictions || 0;
                const team2Score = obj?.team2?.predictions || 0;
                const winner1 = obj?.winner == "team1";
                const winner2 = obj?.winner == "team2";
                return (
                  <div className="p-[15px] mb-[20px] rounded-[20px] bg-[#141414]">
                    <div className="flex items-center gap-[6px] pb-[16px] border-b-[1px] border-[#363636]">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          d="M8.66137 2.649C8.69235 2.58558 8.74052 2.53214 8.80039 2.49476C8.86026 2.45738 8.92942 2.43756 9 2.43756C9.07058 2.43756 9.13974 2.45738 9.19961 2.49476C9.25947 2.53214 9.30764 2.58558 9.33862 2.649L11.1319 6.3C11.187 6.41175 11.2931 6.48938 11.4165 6.50738L15.4264 7.09275C15.7361 7.13812 15.8595 7.52062 15.6356 7.74L12.7339 10.5821C12.6899 10.625 12.657 10.678 12.638 10.7365C12.6191 10.795 12.6147 10.8572 12.6251 10.9178L13.3102 14.9303C13.3631 15.2404 13.0395 15.477 12.7624 15.3307L9.17587 13.4359C9.12171 13.4071 9.06132 13.3921 9 13.3921C8.93867 13.3921 8.87828 13.4071 8.82412 13.4359L5.23762 15.3307C4.9605 15.477 4.63687 15.2407 4.68975 14.9306L5.3745 10.9181C5.38503 10.8575 5.38063 10.7952 5.36168 10.7367C5.34273 10.6781 5.30981 10.6251 5.26575 10.5821L2.36475 7.74C2.1405 7.52062 2.26425 7.13812 2.574 7.09275L6.58425 6.50775C6.70725 6.48938 6.81337 6.41175 6.8685 6.3L8.66137 2.649Z"
                          fill="#FFE100"
                        />
                      </svg>

                      <p className="text-small-medium ">
                        Match Day:{" "}
                        {matchDate == "Invalid Date"
                          ? matchDetails?.matchDate
                          : formattedMatchDate}
                      </p>
                    </div>

                    <div className=" w-full">
                      <div className="my-[18px] flex w-full gap-[17px] justify-evenly items-stretch">
                        {/* Team 1 Container */}
                        <div
                          className="flex flex-col items-center justify-between flex-1 gap-[8px] cursor-pointer"
                          onClick={() => {
                            if (team1Score > 0) {
                              setPredictionPopup({
                                matchDetails: matchDetails,
                                team: "team1",
                                organiserId,
                                campaignId,
                                contestId,
                              });
                            }
                          }}
                        >
                          <div
                            className={`flex flex-col items-center cursor-pointer p-[10px] rounded-[10px] relative w-full ${
                              winner1 && "border-[1px] border-[#FFA82833]"
                            }`}
                          >
                            {winner1 && (
                              <img
                                src={trophy}
                                className="absolute top-[-10px] mx-auto"
                              />
                            )}
                            <div className="w-[62px] h-[62px] rounded-[8px] overflow-hidden bg-white">
                              <img src={matchDetails?.team1?.logo} alt="" />
                            </div>
                            <p className="text-white mt-[12px] text-center text-small-medium">
                              {matchDetails?.team1?.name}
                            </p>
                          </div>
                          <div className="mt-auto px-[8px] py-[5px] bg-[#363636] text-smallest rounded-[10px] text-center opacity-80 w-full flex items-center justify-center">
                            <span className="text-with-outline opacity-1">
                              {team1Score}
                            </span>
                            <p
                              className="pl-[8px]  underline-offset-2 flex items-center"
                              style={{
                                textDecoration:
                                  team1Score > 0 ? "underline" : "",
                              }}
                            >
                              Prediction
                              {team1Score > 0 && (
                                <svg
                                  className="inline-flex align-middle w-[20px] h-[20px]"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  style={{ verticalAlign: "middle" }}
                                >
                                  <g clipPath="url(#clip0_706_57)">
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M15.7072 12.707C15.8947 12.5194 16 12.2651 16 12C16 11.7348 15.8947 11.4805 15.7072 11.293L10.0502 5.63598C9.95797 5.54047 9.84762 5.46428 9.72562 5.41188C9.60361 5.35947 9.47239 5.33188 9.33961 5.33073C9.20684 5.32957 9.07516 5.35487 8.95226 5.40516C8.82936 5.45544 8.71771 5.52969 8.62382 5.62358C8.52993 5.71747 8.45567 5.82913 8.40539 5.95202C8.35511 6.07492 8.32981 6.2066 8.33096 6.33938C8.33212 6.47216 8.3597 6.60338 8.41211 6.72538C8.46452 6.84739 8.5407 6.95773 8.63621 7.04998L13.5862 12L8.63621 16.95C8.45406 17.1386 8.35326 17.3912 8.35554 17.6534C8.35782 17.9156 8.46299 18.1664 8.64839 18.3518C8.8338 18.5372 9.08462 18.6424 9.34681 18.6447C9.60901 18.6469 9.86161 18.5461 10.0502 18.364L15.7072 12.707Z"
                                      fill="white"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_706_57">
                                      <rect
                                        width="24"
                                        height="24"
                                        fill="white"
                                        transform="matrix(-1 0 0 1 24 0)"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              )}
                            </p>
                          </div>
                        </div>

                        {/* VS Icon */}
                        <img src={vsIcon} className="h-auto" />

                        {/* Team 2 Container */}
                        <div
                          className="flex flex-col items-center justify-between flex-1 gap-[8px] cursor-pointer"
                          onClick={() => {
                            if (team2Score > 0) {
                              setPredictionPopup({
                                matchDetails: matchDetails,
                                team: "team2",
                                organiserId,
                                campaignId,
                                contestId,
                              });
                            }
                          }}
                        >
                          <div
                            className={`flex flex-col items-center p-[10px] rounded-[10px] relative w-full ${
                              winner2 && "border-[1px] border-[#FFA82833]"
                            }`}
                          >
                            {winner2 && (
                              <img
                                src={trophy}
                                className="absolute top-[-10px] mx-auto"
                              />
                            )}
                            <div className="w-[62px] h-[62px] rounded-[8px] overflow-hidden bg-white">
                              <img src={matchDetails?.team2?.logo} alt="" />
                            </div>
                            <p className="text-white mt-[12px] text-center text-small-medium">
                              {matchDetails?.team2?.name}
                            </p>
                          </div>
                          <div className="mt-auto px-[8px] py-[5px] bg-[#363636] text-smallest rounded-[10px] text-center opacity-80 w-full flex items-center justify-center">
                            <span className="text-with-outline opacity-1">
                              {team2Score}
                            </span>
                            <p
                              className="pl-[8px] underline-offset-2 flex items-center"
                              style={{
                                textDecoration:
                                  team2Score > 0 ? "underline" : "",
                              }}
                            >
                              Prediction
                              {team2Score > 0 && (
                                <svg
                                  className="inline-flex align-middle w-[20px] h-[20px]"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  style={{ verticalAlign: "middle" }}
                                >
                                  <g clipPath="url(#clip0_706_57)">
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M15.7072 12.707C15.8947 12.5194 16 12.2651 16 12C16 11.7348 15.8947 11.4805 15.7072 11.293L10.0502 5.63598C9.95797 5.54047 9.84762 5.46428 9.72562 5.41188C9.60361 5.35947 9.47239 5.33188 9.33961 5.33073C9.20684 5.32957 9.07516 5.35487 8.95226 5.40516C8.82936 5.45544 8.71771 5.52969 8.62382 5.62358C8.52993 5.71747 8.45567 5.82913 8.40539 5.95202C8.35511 6.07492 8.32981 6.2066 8.33096 6.33938C8.33212 6.47216 8.3597 6.60338 8.41211 6.72538C8.46452 6.84739 8.5407 6.95773 8.63621 7.04998L13.5862 12L8.63621 16.95C8.45406 17.1386 8.35326 17.3912 8.35554 17.6534C8.35782 17.9156 8.46299 18.1664 8.64839 18.3518C8.8338 18.5372 9.08462 18.6424 9.34681 18.6447C9.60901 18.6469 9.86161 18.5461 10.0502 18.364L15.7072 12.707Z"
                                      fill="white"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_706_57">
                                      <rect
                                        width="24"
                                        height="24"
                                        fill="white"
                                        transform="matrix(-1 0 0 1 24 0)"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* <div className="flex w-full items-center gap-[16px] pt-[16px] border-t-[1px] border-[#363636]">
                      <button
                        className="pl-[8px] underline hover:underline underline-offset-2 flex items-center"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <p className="text-small-medium ">View Predictions</p>
                        <svg
                          className="inline-flex align-middle w-[20px] h-[20px]"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          style={{ verticalAlign: "middle" }}
                        >
                          <g clipPath="url(#clip0_706_57)">
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M15.7072 12.707C15.8947 12.5194 16 12.2651 16 12C16 11.7348 15.8947 11.4805 15.7072 11.293L10.0502 5.63598C9.95797 5.54047 9.84762 5.46428 9.72562 5.41188C9.60361 5.35947 9.47239 5.33188 9.33961 5.33073C9.20684 5.32957 9.07516 5.35487 8.95226 5.40516C8.82936 5.45544 8.71771 5.52969 8.62382 5.62358C8.52993 5.71747 8.45567 5.82913 8.40539 5.95202C8.35511 6.07492 8.32981 6.2066 8.33096 6.33938C8.33212 6.47216 8.3597 6.60338 8.41211 6.72538C8.46452 6.84739 8.5407 6.95773 8.63621 7.04998L13.5862 12L8.63621 16.95C8.45406 17.1386 8.35326 17.3912 8.35554 17.6534C8.35782 17.9156 8.46299 18.1664 8.64839 18.3518C8.8338 18.5372 9.08462 18.6424 9.34681 18.6447C9.60901 18.6469 9.86161 18.5461 10.0502 18.364L15.7072 12.707Z"
                              fill="white"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_706_57">
                              <rect
                                width="24"
                                height="24"
                                fill="white"
                                transform="matrix(-1 0 0 1 24 0)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </button>
                    </div> */}
                  </div>
                );
              })}
            </>
          )}
        </div>
      );
      break;
    case "REVIEW":
      galleryJSX = (
        <>
          {!dataloading && contestImageGalleryContents.length == 0 ? (
            <div className="pt-[12px] relative ">
              <p className="px-[20px] relative  entry">All Reviews</p>
              <div className={`relative ${styles.gridig}`}>
                <div className="cursor-pointer relative rounded-[6px] w-full h-[50vw] max-h-[170px] bg-[#929090] bg-opacity-[0.63]" />
                <div className="cursor-pointer relative rounded-[6px] w-full h-[50vw] max-h-[170px] bg-[#929090] bg-opacity-[0.63]" />
                <div className="cursor-pointer relative rounded-[6px] w-full h-[50vw] max-h-[170px] bg-[#929090] bg-opacity-[0.63]" />
                <div className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] ">
                  <p className=" text-regular text-center ">
                    We’re awaiting reviews
                  </p>
                  <p className=" text-regular text-center ">for this contest</p>
                </div>
              </div>
            </div>
          ) : (
            <div className="pt-[20px] relative ">
              <p className="px-[20px] relative  text-large-medium">
                All Reviews
              </p>
              <div className={styles.reviewGrid}>
                {contestImageGalleryContents.map((obj, indexnumber) => {
                  return (
                    <div
                      ref={
                        contestImageGalleryContents.length === indexnumber + 1
                          ? lastElementRef
                          : null
                      }
                      className={styles.reviewBox}
                      onClick={() => {
                        handleClick(obj, indexnumber);
                      }}
                      key={obj._id}
                    >
                      <div className="flex gap-[15px]">
                        <img src={obj?.thumbnailUrl} alt="" />
                        <div>
                          <p
                            className="mb-[5px] text-small-bold"
                            style={{ color: contestDetails?.buttonColor }}
                          >
                            {obj?.participantName}
                          </p>
                          <p className="text-six-line text-small">
                            {obj?.review}
                          </p>
                        </div>
                      </div>
                      <div className="px-[8px] py-[5px] bg-[#363636] text-smallest rounded-[10px] text-center opacity-80 w-fit ml-auto flex items-center justify-center mt-[20px]">
                        View Full Review{" "}
                        <svg
                          className="inline-flex align-middle w-[20px] h-[20px]"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          style={{ verticalAlign: "middle" }}
                        >
                          <g clipPath="url(#clip0_706_57)">
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M15.7072 12.707C15.8947 12.5194 16 12.2651 16 12C16 11.7348 15.8947 11.4805 15.7072 11.293L10.0502 5.63598C9.95797 5.54047 9.84762 5.46428 9.72562 5.41188C9.60361 5.35947 9.47239 5.33188 9.33961 5.33073C9.20684 5.32957 9.07516 5.35487 8.95226 5.40516C8.82936 5.45544 8.71771 5.52969 8.62382 5.62358C8.52993 5.71747 8.45567 5.82913 8.40539 5.95202C8.35511 6.07492 8.32981 6.2066 8.33096 6.33938C8.33212 6.47216 8.3597 6.60338 8.41211 6.72538C8.46452 6.84739 8.5407 6.95773 8.63621 7.04998L13.5862 12L8.63621 16.95C8.45406 17.1386 8.35326 17.3912 8.35554 17.6534C8.35782 17.9156 8.46299 18.1664 8.64839 18.3518C8.8338 18.5372 9.08462 18.6424 9.34681 18.6447C9.60901 18.6469 9.86161 18.5461 10.0502 18.364L15.7072 12.707Z"
                              fill="white"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_706_57">
                              <rect
                                width="24"
                                height="24"
                                fill="white"
                                transform="matrix(-1 0 0 1 24 0)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div>
                {dataloading && (
                  <div>
                    <div className="w-[100vw] max-w-[425px] flex align-center justify-center">
                      <Lottie
                        loop
                        animationData={loadingAnimation}
                        play
                        style={{ width: 200, height: 100 }}
                      />
                    </div>
                    <p className="w-[100%] text-small text-center text-[#7AA4F8]">
                      Loading Reviews
                    </p>
                  </div>
                )}
              </div>
              {!dataloading && contestImageGalleryContents?.length > 8 && (
                <div className="px-[20px] ">
                  {(guestModeEnabled || !viewMore) && (
                    <div
                      className="w-[100%]  text-center  mt-[20px] py-[11px] commonButton flex items-center justify-center gap-[5px]"
                      style={{
                        backgroundColor: "rgba(255, 255, 255, 0.1)",
                      }}
                      onClick={handleViewAllEntries}
                    >
                      <p
                        className="text-[13px] "
                        style={{ color: contestDetails?.buttonColor }}
                      >
                        View All Reviews
                      </p>{" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="6"
                        height="10"
                        viewBox="0 0 6 10"
                        fill="none"
                      >
                        <path
                          d="M1 9L5 5L1 1"
                          stroke={contestDetails?.buttonColor}
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  )}
                </div>
              )}

              <div>
                {error && (
                  <div className="w-[100%] h-[300px] flex flex-col items-center justify-center text-[#787878]">
                    <span className="text-[17px] font-semibold">
                      Something went wrong
                    </span>
                    <span className="text-[14px] font-medium mt-[10px] text-center">
                      Please login or refresh <br /> to continue.
                    </span>
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      );
      break;
    case "SERIES":
      galleryJSX = (
        <div className="pt-[12px] px-[20px] relative">
          <p className="text-large-medium mb-[12px]">Entries</p>

          {groupedEntris?.map((entry, indexnumber) => {
            return (
              <div
                className="p-[15px] mb-[20px] rounded-[20px] bg-[#141414] flex gap-[10px] w-full flex-grow min-w-0 cursor-pointer"
                ref={
                  groupedEntris?.length === indexnumber + 1
                    ? lastElementRef
                    : null
                }
              >
                <div className="p-[10px] rounded-[12px] h-full w-fit bg-[#2F2F2F] flex flex-col gap-[10px]">
                  <p
                    className="text-regular-bold"
                    style={{ color: contestDetails?.buttonColor }}
                  >
                    {entry?.entries && entry?.entries[0]?.participantName}
                  </p>
                  {contestDetails?.series_result_key?.map((series) => {
                    const indexofEntry =
                      series?.index == "last"
                        ? entry?.entries?.length - 1
                        : series.index;
                    return (
                      <p className="text-small-bold whitespace-nowrap">
                        {series?.displayName} :{" "}
                        {entry?.entries &&
                          entry?.entries[indexofEntry] &&
                          entry?.entries[indexofEntry][series?.name]}
                      </p>
                    );
                  })}
                  <p className="text-small-bold whitespace-nowrap">
                    {contestDetails?.series_like == "AVERAGE"
                      ? "Average"
                      : "Total"}{" "}
                    Votes :{" "}
                    {contestDetails?.series_like == "AVERAGE"
                      ? (
                          entry?.entries?.reduce(
                            (sum, item) => sum + (item.likesCount || 0),
                            0
                          ) / entry?.entries?.length
                        ).toFixed(0)
                      : entry?.entries?.reduce(
                          (sum, item) => sum + (item.likesCount || 0),
                          0
                        )}
                  </p>
                </div>
                <div className="flex items-center gap-[10px] overflow-auto customScrollbar">
                  {entry?.entries?.map((obj, index) => (
                    <div
                      className="flex flex-col items-center gap-[5px] shrink-0"
                      onClick={() => setGroupedPopup({ entry, index })}
                    >
                      <img
                        src={obj?.thumbnailUrl}
                        alt=""
                        className="h-[120px] w-[120px] rounded-[20px] object-cover shrink-0 shadow-sm shadow-[#ffffff7d]"
                      />
                      <div>
                        <p
                          className="mb-[5px] text-small-bold"
                          style={{ color: contestDetails?.buttonColor }}
                        >
                          {obj[contestDetails?.entry_display_key] || " "}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
          {mathesLoading && (
            <div>
              <div className="w-full max-w-[425px] flex align-center justify-center">
                <Lottie
                  loop
                  animationData={loadingAnimation}
                  play
                  style={{ width: 200, height: 100 }}
                />
              </div>
              <p className="w-[100%] text-small text-center text-[#7AA4F8]">
                Loading Data
              </p>
            </div>
          )}
        </div>
      );
      break;
    default:
      galleryJSX = (
        <>
          {!dataloading && contestImageGalleryContents.length == 0 ? (
            <div className="pt-[12px] relative ">
              <p className="px-[20px] relative  entry">All Entries</p>
              <div className={`relative ${styles.gridig}`}>
                <div className="cursor-pointer relative rounded-[6px] w-full h-[50vw] max-h-[170px] bg-[#929090] bg-opacity-[0.63]" />
                <div className="cursor-pointer relative rounded-[6px] w-full h-[50vw] max-h-[170px] bg-[#929090] bg-opacity-[0.63]" />
                <div className="cursor-pointer relative rounded-[6px] w-full h-[50vw] max-h-[170px] bg-[#929090] bg-opacity-[0.63]" />
                <div className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] ">
                  <p className=" text-regular text-center ">
                    We’re awaiting entries
                  </p>
                  <p className=" text-regular text-center ">for this contest</p>
                </div>
              </div>
              {/* <div className="w-[100%] pb-[30px] pt-[50px] flex flex-col items-center justify-center  relative z-10 text-center">
              <span
                className=" text-regular-medium"
                style={{ color: contestDetails?.buttonColor }}
              >
                No entries yet
              </span>
              <span className="text-small mt-[10px] text-[#CDCDCD]">
                All the approved entries will be
                <br /> displayed here.
              </span>
            </div> */}
            </div>
          ) : (
            <div className="pt-[20px] relative ">
              <p className="px-[20px] relative  text-large-medium">
                {" "}
                All Entries
              </p>
              <div className={styles.gridig}>
                {contestImageGalleryContents.map((obj, indexnumber) => {
                  if (contestImageGalleryContents.length === indexnumber + 1) {
                    return (
                      <div
                        ref={lastElementRef}
                        className="cursor-pointer relative rounded-[6px]"
                        onClick={() => {
                          handleClick(obj, indexnumber);
                        }}
                        key={obj._id}
                      >
                        {obj.fileType === "image" && (
                          <div className={styles.gridigc}>
                            <img
                              className={styles.gridigcImg}
                              src={obj?.thumbnailUrl}
                              alt=""
                            />
                          </div>
                        )}
                        {obj.fileType.startsWith("audio") && (
                          <div className={styles.gridigc}>
                            <img
                              className={styles.gridigcImg}
                              src={obj?.thumbnailUrl}
                              alt=""
                            />
                          </div>
                        )}
                        {obj.fileType === "video" && (
                          <div className={styles.reletives}>
                            <div className={styles.gridigc}>
                              <img
                                className={styles.gridigcImg}
                                src={obj?.thumbnailUrl}
                                alt=""
                              />
                            </div>
                          </div>
                        )}
                        <div className="absolute top-0 left-0 w-[100%] h-[100%] flex flex-col justify-between py-[4px] px-[8px] text-smallest top-and-bottom-gradient">
                          <div className=" flex items-center justify-between">
                            <div>
                              {obj?.fileUrls?.length > 1 && (
                                <img src={multipleFile} alt="" />
                              )}
                            </div>
                            <div className="flex gap-[5px]">
                              <p className="text-small">
                                {likeMap.get("con" + obj?._id)?.likesCount}
                              </p>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="18"
                                viewBox="0 0 24 21"
                                fill="none"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M12 3.34243C9.80074 0.847315 6.12572 0.0762153 3.37017 2.36099C0.614608 4.64577 0.226662 8.46578 2.39062 11.168C4.18981 13.4147 9.63476 18.1532 11.4193 19.6869C11.6189 19.8585 11.7188 19.9443 11.8353 19.978C11.9368 20.0073 12.048 20.0073 12.1497 19.978C12.2662 19.9443 12.3659 19.8585 12.5657 19.6869C14.3502 18.1532 19.7951 13.4147 21.5943 11.168C23.7583 8.46578 23.4177 4.62174 20.6147 2.36099C17.8118 0.10025 14.1993 0.847315 12 3.34243Z"
                                  fill={
                                    likeMap.get("con" + obj?._id)?.liked
                                      ? "#F11057"
                                      : "#FFFEFE"
                                  }
                                  stroke=""
                                  stroke-width="1.67"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className=" flex items-center justify-between">
                            <p className="truncate max-w-[80%]">
                              {obj?.participantName}
                            </p>
                            {obj.fileType === "video" && (
                              <div className={styles.playbtnBg}>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="26"
                                  height="32"
                                  viewBox="0 0 26 32"
                                  fill="none"
                                >
                                  <path
                                    d="M1.99339 30.8984C2.30915 31.0344 2.66445 31.125 3.01974 31.125C3.57238 31.125 4.12503 30.8984 4.59866 30.5358L24.1382 18.3425L24.3355 18.1159C24.8487 17.5266 25.125 16.8013 25.125 15.9855C25.125 15.1696 24.8487 14.399 24.3355 13.8551L24.1382 13.6284L4.59866 1.34452C3.88814 0.709954 2.8618 0.573977 1.99339 0.981912C1.00652 1.43517 0.375 2.5684 0.375 3.79228V28.0881C0.374935 29.312 1.00652 30.4451 1.99339 30.8984Z"
                                    fill="#FFFEFE"
                                  />
                                </svg>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  } else {
                    return (
                      <div
                        className="cursor-pointer relative rounded-[6px]"
                        onClick={() => {
                          handleClick(obj, indexnumber);
                        }}
                        key={obj._id}
                      >
                        {obj.fileType === "image" && (
                          <div className={styles.gridigc}>
                            <img
                              className={styles.gridigc}
                              src={obj?.thumbnailUrl}
                              alt=""
                            />
                          </div>
                        )}
                        {obj.fileType === "video" && (
                          <div className={styles.reletives}>
                            <div className={styles.gridigc}>
                              <img
                                className={styles.gridigc}
                                src={obj?.thumbnailUrl}
                                alt=""
                              />
                            </div>
                          </div>
                        )}
                        {obj.fileType.startsWith("audio") && (
                          <div className={styles.gridigc}>
                            <img
                              className={styles.gridigcImg}
                              src={obj?.thumbnailUrl}
                              alt=""
                            />
                          </div>
                        )}
                        <div className="absolute top-0 left-0 w-[100%] h-[100%] flex flex-col justify-between py-[4px] px-[8px] text-smallest top-and-bottom-gradient">
                          <div className=" flex items-center justify-between">
                            <div>
                              {obj?.fileUrls?.length > 1 && (
                                <img src={multipleFile} alt="" />
                              )}
                            </div>
                            <div className="flex gap-[5px]">
                              <p className="text-small">
                                {likeMap.get("con" + obj?._id)?.likesCount}
                              </p>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="18"
                                viewBox="0 0 24 21"
                                fill="none"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M12 3.34243C9.80074 0.847315 6.12572 0.0762153 3.37017 2.36099C0.614608 4.64577 0.226662 8.46578 2.39062 11.168C4.18981 13.4147 9.63476 18.1532 11.4193 19.6869C11.6189 19.8585 11.7188 19.9443 11.8353 19.978C11.9368 20.0073 12.048 20.0073 12.1497 19.978C12.2662 19.9443 12.3659 19.8585 12.5657 19.6869C14.3502 18.1532 19.7951 13.4147 21.5943 11.168C23.7583 8.46578 23.4177 4.62174 20.6147 2.36099C17.8118 0.10025 14.1993 0.847315 12 3.34243Z"
                                  fill={
                                    likeMap.get("con" + obj?._id)?.liked
                                      ? "#F11057"
                                      : "#FFFEFE"
                                  }
                                  stroke=""
                                  stroke-width="1.67"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className=" flex items-center justify-between">
                            <p className="truncate max-w-[80%]">
                              {obj?.participantName}
                            </p>
                            {obj.fileType === "video" && (
                              <div className={styles.playbtnBg}>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="26"
                                  height="32"
                                  viewBox="0 0 26 32"
                                  fill="none"
                                >
                                  <path
                                    d="M1.99339 30.8984C2.30915 31.0344 2.66445 31.125 3.01974 31.125C3.57238 31.125 4.12503 30.8984 4.59866 30.5358L24.1382 18.3425L24.3355 18.1159C24.8487 17.5266 25.125 16.8013 25.125 15.9855C25.125 15.1696 24.8487 14.399 24.3355 13.8551L24.1382 13.6284L4.59866 1.34452C3.88814 0.709954 2.8618 0.573977 1.99339 0.981912C1.00652 1.43517 0.375 2.5684 0.375 3.79228V28.0881C0.374935 29.312 1.00652 30.4451 1.99339 30.8984Z"
                                    fill="#FFFEFE"
                                  />
                                </svg>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  }
                })}

                {
                  // <div>
                  //   {clickedImg && (
                  //     <Popup
                  //       clickedImg={clickedImg}
                  //       handelRotationRight={handelRotationRight}
                  //       setClickedImg={setClickedImg}
                  //       handelRotationLeft={handelRotationLeft}
                  //       handleLike={handleLike}
                  //       isLike={like}
                  //       contestContent={contestImageGalleryContents[currentIndex]}
                  //       loading={loading}
                  //       token={userIdToken}
                  //       currentIndex={currentIndex}
                  //       campaignType={campaignType}
                  //     />
                  //   )}
                  // </div>
                }
              </div>
              <div>
                {dataloading && (
                  <div>
                    <div className="w-[100vw] max-w-[425px] flex align-center justify-center">
                      <Lottie
                        loop
                        animationData={loadingAnimation}
                        play
                        style={{ width: 200, height: 100 }}
                      />
                    </div>
                    <p className="w-[100%] text-small text-center text-[#7AA4F8]">
                      Loading Entries
                    </p>
                  </div>
                )}
              </div>
              {!dataloading && contestImageGalleryContents?.length > 8 && (
                <div className="px-[20px] ">
                  {(guestModeEnabled || !viewMore) && (
                    <div
                      className="w-[100%]  text-center  mt-[20px] py-[11px] commonButton flex items-center justify-center gap-[5px]"
                      style={{
                        backgroundColor: "rgba(255, 255, 255, 0.1)",
                      }}
                      onClick={handleViewAllEntries}
                    >
                      <p
                        className="text-[13px] "
                        style={{ color: contestDetails?.buttonColor }}
                      >
                        View All Entries
                      </p>{" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="6"
                        height="10"
                        viewBox="0 0 6 10"
                        fill="none"
                      >
                        <path
                          d="M1 9L5 5L1 1"
                          stroke={contestDetails?.buttonColor}
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  )}
                </div>
              )}

              <div>
                {error && (
                  <div className="w-[100%] h-[300px] flex flex-col items-center justify-center text-[#787878]">
                    <span className="text-[17px] font-semibold">
                      Something went wrong
                    </span>
                    <span className="text-[14px] font-medium mt-[10px] text-center">
                      Please login or refresh <br /> to continue.
                    </span>
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      );
      break;
  }

  return (
    <>
      {!_.isEmpty(predicitonPopup) && (
        <PredictionPopup setPopup={setPredictionPopup} data={predicitonPopup} />
      )}
      {!_.isEmpty(groupedPopup) && (
        <GroupedPopup
          setPopup={setGroupedPopup}
          data={groupedPopup?.entry}
          selectedIndex={groupedPopup?.index}
          contestDetails={contestDetails}
        />
      )}
      {galleryJSX}
    </>
  );
}

export default ImageGallery;
